import { Card } from "react-bootstrap";
import { ContactForm } from "../components";
import {
  ContactPage,
  getAllProducts,
  getConfig,
  getContactData,
} from "../lib/api";

import { getGlobalStaticProps } from "../lib/helpers";
import { getIconPrefix } from "../lib/helpers/get-icon-prefix";
import { Product } from "../lib/models";

interface ContactData {
  locations: string;
  contact_phone: string;
  contact_email: string;
  social_links: { icon: string; url: string }[];
  about: string;
  page: ContactPage;
  products: Product[];
}

export default function Contact({ data }: { data: ContactData }) {
  const {
    page,
    locations,
    contact_phone,
    contact_email,
    social_links,
    about,
    products,
  } = data;
  const { faq } = page;
  return (
    <div className="bg-light">
      {/* Hero */}
      <div className="py-lg-13 py-8 bg-primary">
        <div className="container">
          <div className="row align-items-center">
            <div className="offset-xl-2 col-xl-8 col-lg-12 col-md-12 col-12">
              <div className="text-center mb-6 px-md-8">
                <h1 className="text-white display-3 fw-bold">Contact Us</h1>
                <p className="text-white lead mb-4">
                  We'd love to hear from you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="mt-n8 pb-8">
        <div className="container">
          <div className="row justify-content-center">
            {/* Contact form */}
            <div className="col-lg-6 col-12">
              <Card border="0">
                <Card.Body>
                  <h2>Get in touch</h2>
                  <p className="lead">
                    Send us a message, this will go the team and one of us will
                    get back to you asap, usually the same day.
                    {/* <p>We're ready to help!</p>
                    <p>
                      Whether you need to talk to sales, support, the partner
                      team, or anyone else, we've made it simple to reach out.
                    </p>
                    <p>
                      The fastest way to reach us is using the chat icon in the
                      bottom right of this page. But you're also welcome to send
                      us an email or give us a call.
                    </p> */}
                  </p>
                  <ContactForm products={products} />
                </Card.Body>
              </Card>
            </div>

            {/* Contact details */}
            <div className="col-lg-3 col-12 mt-12">
              <div className="mb-4">
                <h4>About CloudAnswers</h4>
                <div>{about}</div>
              </div>
              <div className="mb-4">
                <h4>Locations</h4>
                <div>{locations}</div>
              </div>
              <div className="mb-4">
                <h4>Phone number</h4>
                <a href={`tel:${contact_phone}`}>{contact_phone}</a>
              </div>
              <div className="mb-4">
                <h4>Email address</h4>
                <a href={`mailto:${contact_email}`}>{contact_email}</a>
              </div>
              <div className="mb-4">
                <h4>Follow us</h4>
                <div>
                  {social_links.map((l) => (
                    <a
                      key={l.url}
                      href={l.url}
                      target="_blank"
                      className={`${getIconPrefix(l.icon)} ${
                        l.icon
                      } text-muted h2 me-2`}
                    ></a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="py-lg-10 py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="mb-8 text-center">
                <h2 className="h1">Frequently Asked Questions</h2>
              </div>
            </div>
          </div>

          <div className="row">
            {faq.map((f) => (
              <div key={f.a} className="col-md-6 col-lg-4 col-12 mb-3">
                <h4>{f.q}</h4>
                {f.link ? (
                  <p dangerouslySetInnerHTML={{ __html: f.a }} />
                ) : (
                  <p>{f.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const page = await getContactData();
  const { locations, contact_phone, contact_email, social_links } =
    await getConfig();
  const data: ContactData = {
    locations,
    contact_phone,
    contact_email,
    social_links,
    about: (await getConfig()).about,
    page,
    products: (await getAllProducts()).sort((a, b) =>
      a.title.localeCompare(b.title)
    ),
  };
  const props = await getGlobalStaticProps(
    { data },
    {
      pageTitle: page.title,
      pageDescription: page.meta_description,
      publishDate: page.date,
      pageImage: page.image,
    }
  );
  return { props };
}
